import idsTokensDefault from '../../utils/tokens/idsTokens';

const TRACK_HEIGHT = 3;

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    minWidth: idsTokens.tabs.default.sizing.min.height,
    minHeight: idsTokens.tabs.default.sizing.min.height,
    paddingTop: idsTokens.tabs.default.spacing.padding.top,
    paddingRight: idsTokens.tabs.default.spacing.padding.right,
    paddingBottom: `calc(${idsTokens.tabs.default.spacing.padding.bottom} - ${TRACK_HEIGHT}px)`,
    paddingLeft: idsTokens.tabs.default.spacing.padding.left,
    fontSize: idsTokens.typography.font.size.base,
    lineHeight: idsTokens.typography.lineHeight.base,
    letterSpacing: idsTokens.typography.spacing.letter.none,
    fontWeight: idsTokens.typography.font.weight.regular,
    backgroundColor: idsTokens.tabs.default.color.background.enabled,
    display: 'flex',
    alignItems: 'center',
    gap: idsTokens.tabs.default.spacing.padding.gap,
    borderTopLeftRadius: idsTokens.tabs.default.radius.horizontal.topLeft,
    borderTopRightRadius: idsTokens.tabs.default.radius.horizontal.topRight,
    borderBottomRightRadius: idsTokens.tabs.default.radius.horizontal.bottomRight,
    borderBottomLeftRadius: idsTokens.tabs.default.radius.horizontal.bottomLeft,
    overflow: 'visible',
    '& .MuiBadge-badge:not(.MuiBadge-invisible)': {
      minWidth: 20,
      height: 20,
      fontSize: idsTokens.typography.font.size.base,
      lineHeight: idsTokens.typography.lineHeight.base,
      letterSpacing: idsTokens.typography.spacing.letter.none,
      fontWeight: idsTokens.typography.font.weight.bold,
      position: 'static',
      transform: 'none',
      marginBottom: 2,
    },
    '& .MuiTab-icon': {
      marginRight: 0,
      color: idsTokens.tabs.default.color.icon.enabled,
      width: idsTokens.tabs.default.sizing.icon.width,
      height: idsTokens.tabs.default.sizing.icon.height,
    },
  },
  textColorPrimary: {
    color: idsTokens.tabs.default.color.label.enabled,
    fontWeight: idsTokens.typography.font.weight.semibold,
    borderBottom: `3px solid ${idsTokens.tabs.default.color.border.enabled}`,
    '&.Mui-focusVisible': {
      backgroundColor: idsTokens.tabs.default.color.background.focus,
      color: idsTokens.tabs.default.color.label.focus,
      '& .MuiTab-icon': {
        color: idsTokens.tabs.default.color.icon.focus,
      },
      '&.Mui-selected': {
        color: idsTokens.tabs.default.color.label.selected.focus,
        '& .MuiTab-icon': {
          color: idsTokens.tabs.default.color.icon.selected.focus,
        },
      },
      '&:after': {
        position: 'absolute',
        top: 0,
        bottom: -5,
        left: 0,
        right: 0,
        content: '""',
        zIndex: 1,
        border: `${idsTokens.functional.borderWidth.focus.default} solid ${idsTokens.functional.color.border.focus}`,
        borderTopLeftRadius: idsTokens.tabs.default.radius.horizontal.topLeft,
        borderTopRightRadius: idsTokens.tabs.default.radius.horizontal.topRight,
        borderBottomRightRadius: idsTokens.tabs.default.radius.horizontal.bottomRight,
        borderBottomLeftRadius: idsTokens.tabs.default.radius.horizontal.bottomLeft,
      },
    },
    '&:hover': {
      color: idsTokens.tabs.default.color.label.hover,
      backgroundColor: idsTokens.tabs.default.color.background.hover,
      fontWeight: idsTokens.typography.font.weight.semibold,
      borderBottom: `3px solid ${idsTokens.tabs.default.color.border.hover}`,
      '& .MuiTab-icon': {
        color: idsTokens.tabs.default.color.icon.hover,
      },
    },
    '&:active': {
      color: idsTokens.tabs.default.color.label.pressed,
      backgroundColor: idsTokens.tabs.default.color.background.pressed,
      borderBottom: `3px solid ${idsTokens.tabs.default.color.border.pressed}`,
      '& .MuiTab-icon': {
        color: idsTokens.tabs.default.color.icon.pressed,
      },
    },
    '&.Mui-selected': {
      color: idsTokens.tabs.default.color.label.selected.enabled,
      fontWeight: idsTokens.typography.font.weight.semibold,
      '& .MuiTab-icon': {
        color: idsTokens.tabs.default.color.icon.selected.enabled,
      },
    },
    '&.Mui-disabled': {
      backgroundColor: idsTokens.tabs.default.color.background.disabled,
      borderBottom: `3px solid ${idsTokens.tabs.default.color.border.disabled}`,
      color: idsTokens.tabs.default.color.label.disabled, //+ 66, // .4 opacity in hex
      '& .MuiTab-icon': {
        color: idsTokens.tabs.default.color.icon.disabled, //+ 66, // .4 opacity in hex
      },
    },
    '&.box': {
      borderTopLeftRadius: idsTokens.tabs.default.radius.horizontal.topLeft,
      borderTopRightRadius: idsTokens.tabs.default.radius.horizontal.topRight,
      borderBottomRightRadius: idsTokens.tabs.default.radius.horizontal.bottomRight,
      borderBottomLeftRadius: idsTokens.tabs.default.radius.horizontal.bottomLeft,
      border: `2px solid ${idsTokens.tabs.default.color.border.enabled}`,
      background: idsTokens.tabs.default.color.background.box.enabled,
      '&.Mui-focusVisible': {
        background: idsTokens.tabs.default.color.background.box.focus,
        overflow: 'visible',
        '&:after': {
          top: -4,
          bottom: -4,
          left: -4,
          right: -4,
        },
        '&.Mui-selected:after': {
          borderRadius: '0px 0px 0px 0px !important',
        },
      },
      '&:hover': {
        border: `2px solid ${idsTokens.tabs.default.color.border.hover}`,
        background: idsTokens.tabs.default.color.background.box.hover,
        '&.Mui-selected': {
          background: idsTokens.tabs.default.color.background.box.hover,
        },
      },
      '&:active': {
        border: `2px solid ${idsTokens.tabs.default.color.border.pressed}`,
        background: idsTokens.tabs.default.color.background.box.pressed,
        '&.Mui-selected': {
          background: idsTokens.tabs.default.color.background.box.pressed,
        },
      },
      '&.Mui-selected': {
        background: idsTokens.tabs.default.color.background.enabled,
        border: `2px solid ${idsTokens.tabs.default.color.background.enabled}`,
      },
      '&.Mui-disabled': {
        background: idsTokens.tabs.default.color.background.box.disabled,
        border: `2px solid ${idsTokens.tabs.default.color.border.disabled}`,
      },
      '&:not(:last-child):not(.vertical)': {
        marginRight: idsTokens.tabs.default.spacing.tabList.box.gap,
      },
    },
    '&.vertical': {
      justifyContent: 'start',
      borderBottom: 'none',
      borderRight: `3px solid ${idsTokens.tabs.default.color.border.enabled}`,
      borderTopLeftRadius: idsTokens.tabs.default.radius.vertical.topLeft,
      borderTopRightRadius: idsTokens.tabs.default.radius.vertical.topRight,
      borderBottomRightRadius: idsTokens.tabs.default.radius.vertical.bottomRight,
      borderBottomLeftRadius: idsTokens.tabs.default.radius.vertical.bottomLeft,
      textAlign: 'left',
      '&.Mui-focusVisible': {
        borderRight: `3px solid ${idsTokens.tabs.default.color.border.focus}`,
        '&:after': {
          bottom: 0,
          right: -5,
          border: `${idsTokens.functional.borderWidth.focus.default} solid ${idsTokens.functional.color.border.focus}`,
          borderTopLeftRadius: idsTokens.tabs.default.radius.vertical.topLeft,
          borderTopRightRadius: idsTokens.tabs.default.radius.vertical.topRight,
          borderBottomRightRadius: idsTokens.tabs.default.radius.vertical.bottomRight,
          borderBottomLeftRadius: idsTokens.tabs.default.radius.vertical.bottomLeft,
        },
      },
      '&:hover': {
        borderRight: `3px solid ${idsTokens.tabs.default.color.border.hover}`,
      },
      '&:active': {
        borderRight: `3px solid ${idsTokens.tabs.default.color.border.pressed}`,
      },
      '&.Mui-disabled': {
        borderRight: `3px solid ${idsTokens.tabs.default.color.border.disabled}`,
      },
      '&.box': {
        border: `2px solid ${idsTokens.tabs.default.color.border.enabled}`,
        '&.Mui-focusVisible': {
          '&:after': {
            bottom: -4,
            right: -4,
          },
        },
        '&:hover': {
          border: `2px solid ${idsTokens.tabs.default.color.border.hover}`,
        },
        '&:active': {
          border: `2px solid ${idsTokens.tabs.default.color.border.pressed}`,
        },
        '&.Mui-selected': {
          border: '2px solid transparent',
        },
        '&:not(:last-child)': {
          marginBottom: idsTokens.tabs.default.spacing.tabList.box.gap,
        },
      },
    },
  },
});
